import {inject, Injectable} from '@angular/core';
import {LobbyStore} from "../../store/lobby.store";
import {GameSettingsStore} from "../../store/game-settings.store";
import {LobbySettings} from "../model/lobby-settings.model";

const STORAGE_KEY = 'lobby-settings';

@Injectable({
  providedIn: 'root'
})
export class LobbySettingsService {

  readonly lobbyStore = inject(LobbyStore);

  readonly gameSettingsStore = inject(GameSettingsStore);

  constructor() { }

  persistSettings() {
    const lobbySettings: LobbySettings = {
      lobbyType: this.lobbyStore.type(),
      winThreshold: this.gameSettingsStore.winThreshold(),
      selectedGenres: this.gameSettingsStore.selectedGenres(),
      customGenres: this.gameSettingsStore.customGenres(),
      gameMode: this.gameSettingsStore.gameMode()
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(lobbySettings));
  }

  getPersistedSettings(): LobbySettings | undefined {
    const lobbySettings = localStorage.getItem(STORAGE_KEY);
    return lobbySettings ? JSON.parse(lobbySettings) : undefined;
  }
}
